import { Route } from '@angular/router';
import { UrlSegment } from '@app/shared/types/enums/url-segment.enum';
import { EditProjectViewComponent } from '@app/views/company/projects/edit-project/edit-project-view.component';
import { ProjectOshViewComponent } from '@app/views/company/projects/project-osh/project-osh-view.component';
import { projectTagsRoutes } from '@app/views/company/projects/project-tags/project-tags.routing';
import { tasksRoutes } from '@app/views/company/projects/tasks/project-tasks.routing';
import { ProjectDetailsViewComponent } from './details/project-details-view.component';
import { ProjectIndustriesViewComponent } from './project-industries/project-industries-view.component';
import { ProjectLocationsViewComponent } from './project-locations/project-locations-view.component';
import { ProjectParticipantsViewComponent } from './project-participants/project-participants-view.component';
import { ProjectsComponent } from './projects.component';

export const projectsRoutes: Route[] = [
  {
    path: '',
    component: ProjectsComponent,
    children: [
      {
        path: UrlSegment.CREATE,
        component: EditProjectViewComponent
      },
      {
        path: ':project-id',
        children: [
          {
            path: UrlSegment.FILES,
            loadComponent: () =>
              import('./project-files/project-files-view.component').then(module => module.ProjectFilesViewComponent)
          },
          {
            path: '',
            redirectTo: UrlSegment.TASKS,
            pathMatch: 'full'
          },
          {
            path: UrlSegment.LOCATIONS,
            component: ProjectLocationsViewComponent
          },
          {
            path: UrlSegment.INDUSTRIES,
            component: ProjectIndustriesViewComponent
          },
          {
            path: UrlSegment.PARTICIPANTS,
            component: ProjectParticipantsViewComponent
          },
          {
            path: UrlSegment.OSH,
            component: ProjectOshViewComponent
          },
          {
            path: UrlSegment.TASKS,
            loadChildren: () => tasksRoutes
          },
          {
            path: UrlSegment.EDIT,
            component: EditProjectViewComponent
          },
          {
            path: UrlSegment.TAGS,
            loadChildren: () => projectTagsRoutes
          },
          {
            path: '',
            component: ProjectDetailsViewComponent
          }
        ]
      }
    ]
  }
];
